import { takeLatest, put, call } from 'redux-saga/effects';

import { listLocalEstoqueCadastro } from '../service';
import {
  TABLE_LOCAL_ESTOQUE_CADASTRO,
  TABLE_LOCAL_ESTOQUE_CADASTRO_PENDING,
  TABLE_LOCAL_ESTOQUE_CADASTRO_SUCCESS,
  TABLE_LOCAL_ESTOQUE_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListLocalEstoqueCadastro(action) {
  yield put({ type: TABLE_LOCAL_ESTOQUE_CADASTRO_PENDING })

  try {
    const table = yield call(listLocalEstoqueCadastro, action.args)
    yield put({ type: TABLE_LOCAL_ESTOQUE_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_LOCAL_ESTOQUE_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListLocalEstoqueCadastro() {
  yield takeLatest(TABLE_LOCAL_ESTOQUE_CADASTRO, sagaListLocalEstoqueCadastro)
}